import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { UNDERWRITING_ACTION_TYPE } from '../actions';

const initialState = {
  expirationDates: {},
  notes: null,
};

const underwritingReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case UNDERWRITING_ACTION_TYPE.GET_UNDERWRITING_DATA:
        return {
          ...(payload || initialState),
          notes: payload.manualNotes.notes || initialState.notes,
        };

      case UNDERWRITING_ACTION_TYPE.EDIT_EXPIRATION_DATES_DATA:
        draft.expirationDates = payload || initialState.expirationDates;

        return draft;

      case UNDERWRITING_ACTION_TYPE.EDIT_NOTES_DATA:
        draft.notes = payload.notes || initialState.notes;

        return draft;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default underwritingReducer;
